// Blog-Seitenleiste (v. a. die lange Tag-Liste) endet bündig mit dem letzten Beitrag.
// Was darüber hinausgeht, wird ausgeblendet und lässt sich per Button aufklappen.
// Nur Desktop (Seitenleiste neben den Beiträgen); mobil steht sie darunter und bleibt komplett.
(function () {
  if (customElements.get("blog-sidebar-balance")) return;

  // Position ohne CSS-Transforms (die Einblend-Animation verschiebt sonst die Messung)
  const docTop = (el) => {
    let y = 0;
    for (let n = el; n; n = n.offsetParent) y += n.offsetTop;
    return y;
  };

  class BlogSidebarBalance extends HTMLElement {
    connectedCallback() {
      this.clamp = this.querySelector("[data-clamp]");
      this.more = this.querySelector("[data-more]");
      const section = this.closest("section");
      this.list = section && section.querySelector(".m-blog__list");
      if (!this.clamp || !this.more || !this.list) return;

      this.expanded = false;
      this.mq = window.matchMedia("(min-width: 1024px)");
      this.update = this.update.bind(this);

      this.more.addEventListener("click", () => {
        this.expanded = !this.expanded;
        this.update();
        if (!this.expanded) this.more.scrollIntoView({ block: "nearest" });
      });

      this.ro = new ResizeObserver(this.update);
      this.ro.observe(this.list);
      this.ro.observe(this.clamp.firstElementChild || this.clamp);
      this.mq.addEventListener("change", this.update);
      window.addEventListener("load", this.update);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.update);
      this.update();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (this.mq) this.mq.removeEventListener("change", this.update);
    }

    reset() {
      this.clamp.style.maxHeight = "";
      this.clamp.classList.remove("is-clamped");
      this.more.hidden = true;
    }

    update() {
      if (!this.mq.matches) return this.reset();

      const listBottom = docTop(this.list) + this.list.offsetHeight;
      const clampTop = docTop(this.clamp);
      const full = this.clamp.scrollHeight;

      // Platz für den Button einplanen, damit dieser bündig mit dem letzten Beitrag abschließt
      this.more.hidden = false;
      const btn = this.more.offsetHeight + parseFloat(getComputedStyle(this.more).marginTop || 0);
      const avail = Math.floor(listBottom - clampTop - btn);

      if (full <= listBottom - clampTop + 1 || avail < 200) return this.reset();

      if (this.expanded) {
        this.clamp.style.maxHeight = "";
        this.clamp.classList.remove("is-clamped");
        this.more.textContent = this.dataset.tLess;
        this.more.setAttribute("aria-expanded", "true");
      } else {
        this.clamp.style.maxHeight = avail + "px";
        this.clamp.classList.add("is-clamped");
        this.more.textContent = this.dataset.tMore;
        this.more.setAttribute("aria-expanded", "false");
      }
    }
  }

  customElements.define("blog-sidebar-balance", BlogSidebarBalance);
})();
